import EntityAudits from "@/components/EntityAudits.vue";
import {
  EntityDocumentForm,
  EntityDocumentMultipleForm,
  EntityDocuments,
  EntityDocumentsChildList,
} from "@modernary/mui/components/document";
import { EntityNotes } from "@modernary/mui/components/note";
import { RouterView, type RouterOptions } from "vue-router";

const names = {
  releases: "Release.Releases",
  list: "Release.ReleaseList",
  base: "Release.ReleaseBase",
  view: "Release.ReleaseView,",
  new: "Release.ReleaseNew",
  edit: "Release.ReleaseEdit",
  notes: "Release.ReleaseNotes",
  noteEdit: "Release.ReleaseNoteEdit",
  noteNew: "Release.ReleaseNoteNew",
  documents: "Release.ReleaseDocuments",
  documentEdit: "Release.ReleaseDocumentEdit",
  documentNew: "Release.ReleaseDocumentNew",
  audit: "Release.ReleaseAudit",
};

export { names as releaseRouteNames };

const releaseRoutes: RouterOptions["routes"] = [
  {
    path: "/releases",
    name: names.releases,
    component: {
      render: () => <RouterView />,
    },
    redirect: { name: names.list },
    children: [
      {
        path: "list",
        name: names.list,
        meta: { title: "Releases", lookupGroups: ["ReleaseStatus"] },
        component: () => import("@/views/release/ReleaseList.vue"),
      },
      {
        path: "new/:facilityId(\\d+)?",
        component: () => import("@/views/release/ReleaseBase.vue"),
        redirect: { name: names.new },
        props: true,
        children: [
          {
            path: "",
            name: names.new,
            meta: { title: "Release New", isNew: true },
            component: () => import("@/views/release/ReleaseEdit.vue"),
          },
        ],
      },
      {
        path: ":id(\\d+)",
        name: names.base,
        component: () => import("@/views/release/ReleaseBase.vue"),
        redirect: { name: names.view },
        children: [
          {
            path: "view",
            name: names.view,
            meta: { title: "Release View" },
            component: () => import("@/views/release/ReleaseView.vue"),
          },
          {
            path: "edit",
            name: names.edit,
            meta: { title: "Release Edit", isForm: true },
            component: () => import("@/views/release/ReleaseEdit.vue"),
          },
          {
            path: "notes",
            name: names.notes,
            meta: { title: "Release Notes" },
            component: {
              render: () => <EntityNotes idField="releaseId" routeNamePrefix="Release.ReleaseNote" />,
            },
          },
          {
            path: "notes/:annotationId(\\d+)",
            name: names.noteEdit,
            meta: { title: "Release Note Edit", isForm: true },
            component: () => import("@/views/release/ReleaseNote.vue"),
          },
          {
            path: "notes/new",
            name: names.noteNew,
            meta: { title: "Release Note New", isForm: true },
            component: () => import("@/views/release/ReleaseNote.vue"),
          },
          {
            path: "documents",
            name: names.documents,
            meta: { title: "Release Documents" },
            component: {
              render: () => <EntityDocumentsChildList resourceTypeKey="release" />,
            },
          },
          {
            path: "documents/:documentId(\\d+)",
            name: names.documentEdit,
            meta: { title: "Release Document Edit", isForm: true },
            component: {
              render: () => <EntityDocumentForm resourceTypeKey="release" />,
            },
          },
          {
            path: "documents/new",
            name: names.documentNew,
            meta: { title: "Release Document New", isForm: true },
            component: {
              render: () => <EntityDocumentMultipleForm resourceTypeKey="release" />,
            },
          },
          {
            path: "activity",
            name: names.audit,
            meta: { title: "Release Audit Activity" },
            component: {
              render: () => <EntityAudits entityName="Release" />,
            },
          },
        ],
      },
    ],
  },
];
export default releaseRoutes;
